import { render, staticRenderFns } from "./bizCardPage.vue?vue&type=template&id=73124f47&scoped=true&"
import script from "./bizCardPage.vue?vue&type=script&lang=js&"
export * from "./bizCardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73124f47",
  null
  
)

export default component.exports